import { createSelector } from '@reduxjs/toolkit';
import { TStoreState } from 'redux/types';
import { TVatReimbursementState } from './types';

const getVatReimbursementState = (state: TStoreState): TVatReimbursementState =>
	state.vatReimbursement;
export const getVatReimbursement = createSelector(
	[getVatReimbursementState],
	(vatReimbursement: TVatReimbursementState) => vatReimbursement,
);

// ====================================================:

export const getVatReimbursements = createSelector(
	[getVatReimbursement],
	(vatReimbursement: TVatReimbursementState) => vatReimbursement.vatReimbursements,
);

// ====================================================:

export const getVatReimbursementsLoading = createSelector(
	[getVatReimbursement],
	(vatReimbursement: TVatReimbursementState) => vatReimbursement.vatReimbursementsLoading,
);

// ====================================================:

export const getReceiveVatReimbursementLoading = createSelector(
	[getVatReimbursement],
	(vatReimbursement: TVatReimbursementState) => vatReimbursement.receiveVatReimbursementLoading,
);

// ====================================================:

export const getUpdateCommentLoading = createSelector(
	[getVatReimbursement],
	(vatReimbursement: TVatReimbursementState) => vatReimbursement.updateCommentLoading,
);
